module.exports = __webpack_public_path__ + "static/logo-111d308799f72b110ae02268fb5b383f.png";